<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Cupon de Descuento - Ver</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form">
              <b-row>

                <b-col md="6">
                  <b-form-group label="Nombre:">
                    <b-form-input type="text" disabled v-model="discount_coupon.name" required placeholder="Ingrese su nombre"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Tipo:">
                    <b-form-select disabled v-model="discount_coupon.discount_type" :options="discount_type"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Descuento:" required>
                    <b-form-input type="number" step="any" disabled v-model="discount_coupon.discount"></b-form-input>
                  </b-form-group>
                </b-col>

      
                <b-col md="2">
                  <b-form-group label="Estado :">
                    <b-form-select disabled v-model="discount_coupon.state" :options="state"></b-form-select>
                  </b-form-group>
                </b-col>
         

     
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <LoadingComponent :is-visible="isLoading"/>
    <Keypress key-event="keyup" :key-code="115" @success="Validate" />
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import LoadingComponent from './../pages/Loading'
export default {
  name: "UsuarioAdd",
   props: ["id"],
  components:{
    Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module:'DiscountCoupon',
      discount_coupon: {
        id: "",
        name: "",
        descripcion: "",
        discount_type: "",
        discount: "",
        state: 1,
      },
      discount_type: [
        {value: '' , text : 'Seleccione un tipo'},
        {value: 'Porcentaje' , text : 'Porcentaje'},
        {value: 'Monto' , text : 'Monto'},
      ],
      state:[
        {value: 1 , text : 'Activo'},
        {value: 0 , text : 'Inactivo'},
      ],
      //errors
      errors: {
        name: false,
        discount_type: false,
        discount: false,
      },
      error_discount :'',
      validate: false,
    };
  },
  mounted() {
    this.viewDiscountCoupon();
  },
  methods: {
    viewDiscountCoupon,
  },
  computed: {
    
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function viewDiscountCoupon() {
  let me = this;
  me.isLoading = true;
  let id = je.decrypt(me.id);
  let url = me.url_base + "discount-coupons/view/" + id;
  axios({
    method: "GET",
    url: url,
    headers: { token: me.token, module: me.module, role: 5},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.discount_coupon.id = response.data.result.id;
        me.discount_coupon.name = response.data.result.name;
        me.discount_coupon.discount_type = response.data.result.discount_type;
        me.discount_coupon.discount = response.data.result.discount;
        me.discount_coupon.state = response.data.result.state;

      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
  
}

</script>
